import React, { useEffect, useState } from "react";
import markerImage from "../assets/images/sound.png";
import { Marker, Popup } from "react-leaflet";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";

import L from "leaflet";

const SoundMarker = (props) => {
  const defaultToken = process.env.REACT_APP_API_TOKEN;
  const defaultApiString = useSelector((state) => state.login.defaultApiString);
  const isLoggedIn = useSelector((state) => state.login.accessToken);
  const [LEQData, setLEQData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const soundIcon = L.icon({
    iconUrl: markerImage,
    iconSize: [18, 40],
    iconAnchor: [7, 20],
    popupAnchor: [4, -5],
  });

  const convertToJalali = (x) => {
    const A = x.slice(0, 10);
    const B = x.slice(11, 19);
    const C = new Date(A);
    const formattedDate = new Intl.DateTimeFormat("fa-IR").format(C);
    return formattedDate + " (" + B + ")";
  };

  const convertToJalaliDate = (x) => {
    const A = x.slice(0, 10);
    const C = new Date(A);
    const formattedDate = new Intl.DateTimeFormat("fa-IR").format(C);
    return formattedDate;
  };

  const navigate = useNavigate();
  const navigateToSoundHistory = (theRouteUrl) => {
    const navigateUrl = "/sound-data/" + theRouteUrl;
    navigate(navigateUrl);
  };

  const navigateToSoundCharts = (theRouteUrl) => {
    const navigateUrl = "/soundStation-charts/" + theRouteUrl;
    navigate(navigateUrl);
  };

  const shouldShowTheWord = () => {
    const shouldShow = /^ایستگاه/;
    return !shouldShow.test(props.data.stationName);
  };

  // Safely access props.data properties with a null check or optional chaining
  if (!props.data || !props.data.latitude || !props.data.longitude) {
    return null; // Don't render anything if data is invalid
  }

  if (props.type === "OSPL") {
    return (
      <Marker
        position={[props.data.latitude, props.data.longitude]}
        icon={soundIcon}
      >
        <Popup position={[props.data.latitude, props.data.longitude]}>
          <div className="text-center p-2" style={{ width: "300px" }}>
            {shouldShowTheWord() ? (
              <h5 className="mt-3">ایستگاه {props.data.stationName}</h5>
            ) : (
              <h5 className="mt-3">{props.data.stationName}</h5>
            )}
          </div>
          <div className="border bg-secondary text-bg-secondary text-center">
            <div className="row">
              <div className="col">
                <p className="popupText">
                  <strong>شهر : </strong>
                  {props.data.city}
                </p>
              </div>
              <div className="col">
                <p className="popupText">
                  <strong>استان : </strong>
                  {props.data.province}
                </p>
              </div>
            </div>
            <div>
              <div className="row">
                <div className="col">
                  {props.dataType === "spl" ? (
                    <p className="popupText">
                      <strong>SPL: </strong>
                      {Number(props.data.spl).toFixed(1)}
                      <sub> dB</sub>
                    </p>
                  ) : (
                    <p className="popupText">
                      <strong>LEQ: </strong>
                      {Number(props.data.leq).toFixed(1)}
                      <sub> dB</sub>
                    </p>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {props.data.humidity ? (
                    <p className="popupText">
                      <strong>Relative Humidity: </strong>
                      {Number(props.data.humidity).toFixed(1)}
                      <sub> %RH</sub>
                    </p>
                  ) : props.data.humidity_avg ? (
                    <p className="popupText">
                      <strong>Relative Humidity: </strong>
                      {Number(props.data.humidity_avg).toFixed(1)}
                      <sub> %RH</sub>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {props.data.temperature ? (
                    <p className="popupText">
                      <strong>Temperature: </strong>&nbsp;
                      {Number(props.data.temperature).toFixed(1)}
                      <sub> ℃</sub>
                    </p>
                  ) : props.data.temperature_min ? (
                    <p className="popupText">
                      <strong>Temperature: </strong>&nbsp;
                      {Number(props.data.temperature_min).toFixed(1)}
                      <sub> ℃</sub>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {props.data.pressure_amb ? (
                    <p className="popupText">
                      <strong>Pressure: </strong>&nbsp;
                      {Number(props.data.pressure_amb).toFixed(1)}
                      <sub> kPa</sub>
                    </p>
                  ) : props.data.pressure_amb_avg ? (
                    <p className="popupText">
                      <strong>Pressure: </strong>&nbsp;
                      {Number(props.data.pressure_amb_avg).toFixed(1)}
                      <sub> kPa</sub>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row my-4 mx-1">
                <div className="col">
                  {props.data.created_datetime ? (
                    <h6 dir="rtl">
                      <strong>آخرین دیتا: </strong> &nbsp;
                      <span className="ss01 text-white" dir="ltr">
                        {convertToJalali(props.data.created_datetime)}
                      </span>
                    </h6>
                  ) : props.dataType === "hourly" ? (
                    <h6 dir="rtl">
                      <strong>آخرین دیتا: </strong> &nbsp;
                      <span className="ss01 text-white" dir="ltr">
                        {convertToJalali(props.data.ccreated_datetime)}
                      </span>
                    </h6>
                  ) : props.data.ccreated_datetime ? (
                    <h6 dir="rtl">
                      <strong>آخرین دیتا: </strong> &nbsp;
                      <span className="ss01 text-white" dir="ltr">
                        {convertToJalaliDate(props.data.ccreated_datetime)}
                      </span>
                    </h6>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr />

              {isLoggedIn ? (
                <div className="d-inline p-0">
                  <button
                    className="btn btn-dark m-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigateToSoundHistory(props.data.slug)}
                  >
                    تاریخچه
                  </button>
                  <button
                    className="btn btn-primary m-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigateToSoundCharts(props.data.slug)}
                  >
                    نمودارها
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </Popup>
      </Marker>
    );
  }
};

export default SoundMarker;
